import React from 'react';
import styled from "styled-components";
import {maxCol} from "../function/SizeCol";
import {graphql, useStaticQuery} from "gatsby";
import GlobalStyles from "../assets/styles/GlobalStyles";
import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import ScrollTopButton from "../function/ScrollTopButton";
import Organization from "../micromarkup/Organization";
import OnlineStore from "../micromarkup/OnlineStore";
import Products from "../micromarkup/Products";
import Series from "../micromarkup/Series";
import Article from "../micromarkup/Article";
import AboutPage from "../micromarkup/AboutPage";

export function Head() {
    return (
        <>
            <title>
                Видавництво Molfar
            </title>
            <meta name="description"
                  content={`---`}
            />
        </>
    )
}

const PageMaintenance  = (props) => {
    // console.log('PageDefault >>>>>', props)

    const data = useStaticQuery(graphql`
    {
      wp {
        acfThemeGeneralSettings {
          aCFoptionTemplate {
            groupMaintenance {
                maintenanceActive 
                title
                text
            } 
          } 
        } 
      } 
    }  
  `);

    const groupMaintenance = data.wp.acfThemeGeneralSettings.aCFoptionTemplate.groupMaintenance;

    return (
        <>
            <div className={`body template-page404 colorRevers`}>
                <GlobalStyles />
                <div className="container">
                    <div className="wrapMain border-ver">

                        <Main className='main'>

                            <Section className="section page404-page">
                                <div className='wrapContainer'>
                                    <div className="row">
                                        {/*{*/}
                                        {/*    groupMaintenance?.banner?.localFile?.publicURL ? (*/}
                                        {/*        <div className="col-lg d-flex d-lg-block justify-content-center">*/}
                                        {/*            <img src={groupMaintenance?.banner?.localFile?.publicURL}  />*/}
                                        {/*        </div>*/}
                                        {/*    ) : ''*/}
                                        {/*}*/}

                                        <div className="col-lg-auto d-flex flex-column d-flex align-items-center align-items-lg-end justify-content-center">
                                            <div className='wrap tc5'>
                                                <h1 className='h2 ttu title'>
                                                    {groupMaintenance?.title}
                                                </h1>
                                                <p className='desc'>
                                                    {groupMaintenance?.text}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Section>

                        </Main>
                    </div>
                </div>

                {/*<Footer isFrontPage={getDataPageContext?.isFrontPage} />*/}


            </div>


        </>
    );
};
export default PageMaintenance;

const Main = styled.div`
    &:before {
        content: '';
        display: block; 
        position: absolute; 
        left: -2000px;
        right: -2000px;
        background-color: var(--paper);
        height: 0.2rem;
        top: 1.8rem;
    }
`;

const Section = styled.section`
    width: 100%;
    background-color: var(--dark);
    //padding-top: 3.8rem;
    //padding-bottom: 3.8rem;
    .wrapContainer {
        max-width: 90rem;
        width: 100%;
        @media (max-width: ${maxCol.md}) {
            padding: 2.4rem;
        }
        @media (max-width: 380px) {
            padding: 1.4rem;
        }
    }
    .wrap {
        //max-width: 31rem;
        //display: inline-block;
    }
    .title {
        margin-bottom: 2.4rem;
        @media (max-width: 410px) {
            br {
                display: none;
            }
        }
    }
    .desc {
        margin-bottom: 4.2rem;
    }

    @media (max-height: 720px) {
        img {
            display: none;
        }
    }
    
`;

